import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useState } from "react";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { Button, Spinner } from "reactstrap";
import OrdersService from "src/apis/OrdersService";

const DownloadInvoiceButton = ({ t, token, orderId }) => {
    const [downloadStatus, setDownloadStatus] = useState(null);

    const downloadFromUrl = (url) => {
        axios.get(url,
            {
                responseType: "blob",
                headers: {},
                onDownloadProgress: (e) => {
                    let percentCompleted = Math.round(e.loaded * 100 /
                        e.total);

                    if (percentCompleted >= 100) {
                        setDownloadStatus('completed');
                    }
                }
            }
        ).then((e) => {
            const url = window.URL.createObjectURL(
                new Blob([e.data], { type: "*" })
            );

            const link = document.createElement("a");

            link.href = url;
            link.setAttribute("download", `invoice_${orderId}.pdf`);

            document.body.appendChild(link);

            link.click();
            link.remove();
        }).catch(() => {
            toast(t("An error occurred while downloading the file."), {
                type: "error",
            });

            setDownloadStatus('failed');
        })
    }

    const fetchOrderInvoiceLinkUrl = useQuery({
        queryKey: [
            "app-fetch-order-invoice-download-link-query",
            "wb",
            orderId
        ],
        queryFn: async () => {
            const ordersService = OrdersService.getInstance();

            return await ordersService.getOrderInvoiceLinkUrl(orderId);
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('Invoice link is not available.'), {
                type: "error"
            });

            setDownloadStatus(null);
        },
        onSuccess: ({ url }) => {
            if (url) {
                downloadFromUrl(url);
            } else {
                toast(t('Invoice link is not available.'), {
                    type: "error"
                });

                setDownloadStatus(null);
            }
        }
    });

    const handleStartDownload = () => {
        setDownloadStatus('downloading');

        fetchOrderInvoiceLinkUrl.refetch();
    }

    return (
        <Button 
            color="primary"
            onClick={handleStartDownload}
            disabled={downloadStatus === 'downloading'}
        >
            {downloadStatus === 'downloading' ? (
                <>
                    <Spinner color="white" size='sm' className="me-2" />
                    {t('Downloading')}...
                </>
            ) : (
                <>
                    <i className="ri-file-pdf-line me-1" />
                    {t('Download Invoice')}
                </>
            )}
        </Button>
    )
}

const mapStatetoProps = (state) => {
    const { token } = state.Login;
    return { token };
};

export default withNamespaces()(
    connect(mapStatetoProps)(
        DownloadInvoiceButton
    )
);